import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getUserListFromDb,
  clearUserListState,
} from "../redux/slices/getUserListSlice";
import { setEditUserData } from "../redux/slices/editUserDataSlice";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Axios from "axios";
import axios from "axios";
import moment from "moment";
import AlertDeleteModal from "./AlertDelete/AlertDeleteModal";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PersonIcon from "@mui/icons-material/Person";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import { Dropdown } from "react-bootstrap";
import "../styles/Users.css";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
import translations from "../assets/locals/translations";
import Checkbox from "@mui/material/Checkbox";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { setShowMessage } from "../redux/slices/notificationSlice";
import msg from "../assets/images/addmessage.png";
import FilterButton from "./FilterAltIcon";
import ExcelColumn from "./tool/ExcelColumn";
import DataGridTable from "./table/DataGridTable";
import ToolPanel from "./table/panel/ToolPanel";
import MovetoStageMenu from "./stages/MovetoStageMenu";
import { FadeLoader } from "react-spinners";
export { getUserListFromDb };

export default function EnquiryList() {
  const location = useLocation();
  const dispatch = useDispatch();
  const ev_stage = location.state?.type || null;
  const [loading, setLoading] = useState(false);
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations["en"];
  const [excelKey, setExcelKey] = useState(null);
  const [excelColumns, setExcelColumns] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [showComponent, setShowComponent] = useState(false);
  const [showComponentc, setShowComponentc] = useState(false);
  const [customerId, setCustomerId] = useState([]);
  const [enquiryId, setEnquiryId] = useState(null);
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [selectedItemData, setSelectedItemData] = useState([]);
  const [selecteduser, setSelectedUser] = useState({});
  const [selectedCategory, setSelectedCategory] = useState({});
  const [modalData, setModalData] = useState({
    show: false,
    rowData: null,
  });
  const [selectedEmployeeIDs, setSelectedEmployeeIDs] = useState([]);
  const [csvFile, setCsvFile] = useState("No File Selected");
  const [id, setId] = useState(null);
  const [enquiryColumnShowHideModel, setEnquiryColumnShowHideModel] = useState(
    {}
  );
  const [selectionModel, setSelectionModel] = useState([]);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [filterEntity, setFilterEntity] = useState("");
  const [type, setType] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [newEnquiryList, setNewEnquiryList] = useState({
    listDsp: [],
  });
  const [startDate, setStartDate] = useState(null);
  const [statusDropDown, setStatusDropDown] = useState("none");
  const [isHovered, setIsHovered] = useState(false);
  const [filterModel, setFilterModel] = useState({ items: [] });
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedType, setSelectedType] = useState("All");
  const [hovered, setHovered] = useState(null);
  const [Category, setCategory] = useState(2);
  const [showModal, setShowModal] = useState(false);

  // Display: each word — first letter capital, rest small
  const toTitleCase = (str) =>
    typeof str === "string" && str.length
      ? str
          .split(/\s+/)
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join(" ")
      : str ?? "";
  const formatDisplayNumber = (val) => {
    if (val === null || val === undefined || val === "") return val;
    const n = Number(val);
    return Number.isFinite(n)
      ? new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n)
      : val;
  };

  const [isAvailable, setIsAvailable] = useState({
    NEW: false,
    HOT: false,
    COLD: false,
    WARM: false,
    OLD: false,
  });
  const [columns, setColumns] = useState({
    NEW: [
      { field: "indexID", headerName: "ID", width: 90 },
      {
        field: "first_name",
        headerAlign: "left",
        align: "left",
        headerName: translations[currentLanguage].firstname,
        minWidth: 310,
        flex: 1,
        renderCell: (params) => {
          const fistName = params.row.first_name || " ";
          return (
            <div
              style={{
                textDecoration: "underline",
                color: "#000102",
                cursor: "pointer",
              }}
              onClick={() => {
                editEnquiryCell(params.row);
              }}
            >
              {toTitleCase(fistName)}
            </div>
          );
        },
      },
      {
        field: "sales_person",
        headerName: translations[currentLanguage].salesp,
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.sales_person || ""),
      },
      {
        field: "stage_name",
        headerName: "Stage Name",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.stage_name || ""),
      },
      {
        field: "village",
        headerName: translations[currentLanguage].village,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.village || ""),
      },
      {
        field: "taluka",
        headerName: translations[currentLanguage].taluka,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.taluka || ""),
      },
      {
        field: "district",
        headerName: translations[currentLanguage].district,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.district || ""),
      },
      {
        field: "phone_number",
        headerName: translations[currentLanguage].phoneno,
        minWidth: 120,
        flex: 1,
      },
      {
        field: "whatsapp_number",
        headerName: "WhatsApp Number",
        minWidth: 150,
        flex: 1,
      },

      {
        field: "manufacturer_name",
        headerName: "Manufacture Name",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.manufacturer_name || ""),
      },
      {
        field: "new_modal",
        headerName: "Model Name",
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          const product =
            params.row.new_modal === "null" ? "  " : params.row.new_modal;
          return <div>{toTitleCase(product)}</div>;
        },
      },
      {
        field: "new_tractor_price",
        headerName: "New Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.new_tractor_price || 0)}`,
      },
      {
        field: "old_details",
        headerName: "Old Tractors",
        headerAlign: "left",
        align: "left",
        minWidth: 250,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.old_details || ""),
      },
      {
        field: "old_tractor_price",
        headerName: "Old Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.old_tractor_price || 0)}`,
      },
      {
        field: "delivery_date",
        headerName: translations[currentLanguage].expdelivery,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.delivery_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      // {
      //   field: "category_name",
      //   headerName: translations[currentLanguage].category,
      //   minWidth: 200,
      //   headerAlign: "left",
      //   align: "left",
      //   flex: 1,
      //   renderCell: (params) => {
      //     const category = params.row.enquiry_category_id || "";
      //     const rowId = params.row.id;
      //     return (
      //       <div className="">
      //         {showSelectionBox[rowId] ? (
      //           <select
      //             onChange={(e) => onChangeEnquiryCategory(e, params.row.id)}
      //             // className={statusDropDown}
      //             className={`custom-select ${statusDropDown}`}
      //             name="category_name"
      //             value={params.row.category_name}
      //           >
      //             <option value="">{params.row.category_name}</option>
      //             {newAddCategory.listTaskCategory?.length > 0 &&
      //               newAddCategory.listTaskCategory.map((i) => (
      //                 <option key={i.id} value={i.id} className="">
      //                   {i.category_name}
      //                 </option>
      //               ))}
      //           </select>
      //         ) : (
      //           <p
      //             className="clickable-text rounded-pill px-4"
      //             onClick={() => handleTaskStatus(rowId)}
      //           >
      //             {params.row.category_name}
      //           </p>
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        field: "enquiry_date",
        headerName: translations[currentLanguage].enqdate,
        headerAlign: "left",
        align: "left",
        minWidth: 130,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.enquiry_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "primary_source",
        headerName: "Primary Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.primary_source || ""),
      },
      {
        field: "enquiry_source",
        headerName: "Enquiry Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.enquiry_source || ""),
      },
      {
        field: "created_by",
        headerName: "Created By",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.created_by || ""),
      },
      {
        field: "menu",
        headerName: (
          <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
        ),
        className: "bg-dark",
        sortable: false,
        filterable: false,
        headerAlign: "right",
        align: "right",
        disableColumnMenu: true,
        width: 180,
        // flex: 1,
        position: "sticky",
        renderCell: (params) => (
          <div className="d-flex justify-content-center dotHoverempicon">
            <FontAwesomeIcon icon={faEllipsisV} />
            <div className="expandDiv expandDivenq">
              <Tooltip title="Work Assign">
                <button
                  className="myActionBtn m-1"
                  onClick={() => {
                    handleworkAssign(params.row, true);
                  }}
                >
                  <PersonIcon />
                </button>
              </Tooltip>
              <Tooltip title="Edit">
                <button
                  onClick={() => {
                    editEnquiryCell(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Delete">
                <button
                  onClick={() => {
                    deleteActionCall(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-trash3"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Move to Stage">
                <div
                  className="position-relative"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <button
                    className="myActionBtn m-1"
                    onClick={() => handleStageClick(params.row)}
                  >
                    <LabelImportantIcon />
                  </button>
                </div>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ],
    HOT: [
      { field: "indexID", headerName: "ID", width: 90 },
      {
        field: "first_name",
        headerAlign: "left",
        align: "left",
        headerName: translations[currentLanguage].firstname,
        minWidth: 310,
        flex: 1,
        renderCell: (params) => {
          const fistName = params.row.first_name || " ";
          const nextFollowupDate = params.row.next_followup_date;
          const isOverdue =
            nextFollowupDate &&
            moment(nextFollowupDate).isValid() &&
            moment(nextFollowupDate).isBefore(moment(), "day");
          return (
            <div
              style={{
                textDecoration: "underline",
                color: isOverdue ? "red" : "#000102",
                cursor: "pointer",
              }}
              onClick={() => {
                editEnquiryCell(params.row);
              }}
            >
              {toTitleCase(fistName)}
            </div>
          );
        },
      },
      {
        field: "sales_person_name",
        headerName: translations[currentLanguage].salesp,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
      },

      {
        field: "stage_name",
        headerName: "Stage Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "next_followup_date",
        headerName: "Next Followup Date",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.next_followup_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "village_name",
        headerName: translations[currentLanguage].village,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "taluka_name",
        headerName: translations[currentLanguage].taluka,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "district_name",
        headerName: translations[currentLanguage].district,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "phone_number",
        headerName: translations[currentLanguage].phoneno,
        minWidth: 150,
        flex: 1,
      },
      {
        field: "whatsapp_number",
        headerName: "WhatsApp Number",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "manufacturer_name",
        headerName: "Manufacture Name",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "new_modal",
        headerName: "Model Name",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "new_tractor_price",
        headerName: "New Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.new_tractor_price || 0)}`,
      },
      {
        field: "old_details",
        headerName: "Old Tractors",
        headerAlign: "left",
        align: "left",
        minWidth: 250,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.old_details || ""),
      },
      {
        field: "old_tractor_price",
        headerName: "Old Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.old_tractor_price || 0)}`,
      },
      {
        field: "delivery_date",
        headerName: translations[currentLanguage].expdelivery,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.delivery_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "primary_source",
        headerName: "Primary Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.primary_source || ""),
      },
      {
        field: "enquiry_source",
        headerName: "Enquiry Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.enquiry_source || ""),
      },
      {
        field: "enquiry_date",
        headerName: "Enquiry date",
        headerAlign: "left",
        align: "left",
        minWidth: 130,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.enquiry_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "created_by",
        headerName: "Created By",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.created_by || ""),
      },
      {
        field: "payment_mode",
        headerName: "Payment Method",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.payment_mode || ""),
      },
      {
        field: "payment_details",
        headerName: "Payment Details",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.payment_details || ""),
      },

      {
        field: "last_discussion",
        headerName: "Last Discussion",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.last_discussion || ""),
      },
      {
        field: "last_followup_date",
        headerName: "Last Followup Date",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.last_followup_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "last_followed_person",
        headerName: "Last Followup Person",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.last_followed_person || ""),
      },
      {
        field: "menu",
        headerName: (
          <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
        ),
        className: "bg-dark",
        sortable: false,
        filterable: false,
        headerAlign: "right",
        align: "right",
        disableColumnMenu: true,
        width: 180,
        // flex: 1,
        position: "sticky",
        renderCell: (params) => (
          <div className="d-flex justify-content-center dotHoverempicon">
            <FontAwesomeIcon icon={faEllipsisV} />
            <div className="expandDiv expandDivenq">
              <Tooltip title="Edit">
                <button
                  onClick={() => {
                    editEnquiryCell(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Delete">
                <button
                  onClick={() => {
                    deleteActionCall(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-trash3"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Move to Stage">
                <div
                  className="position-relative"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <button
                    className="myActionBtn m-1"
                    onClick={() => handleStageClick(params.row)}
                  >
                    <LabelImportantIcon />
                  </button>
                </div>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ],
    COLD: [
      { field: "indexID", headerName: "ID", width: 90 },
      {
        field: "first_name",
        headerAlign: "left",
        align: "left",
        headerName: translations[currentLanguage].firstname,
        minWidth: 310,
        flex: 1,
        renderCell: (params) => {
          const fistName = params.row.first_name || " ";
          return (
            <div
              style={{
                textDecoration: "underline",
                color: "#000102",
                cursor: "pointer",
              }}
              onClick={() => {
                editEnquiryCell(params.row);
              }}
            >
              {toTitleCase(fistName)}
            </div>
          );
        },
      },
      {
        field: "sales_person_name",
        headerName: translations[currentLanguage].salesp,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
      },

      {
        field: "stage_name",
        headerName: "Stage Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "next_followup_date",
        headerName: "Next Followup Date",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.next_followup_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "village_name",
        headerName: translations[currentLanguage].village,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "taluka_name",
        headerName: translations[currentLanguage].taluka,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "district_name",
        headerName: translations[currentLanguage].district,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "phone_number",
        headerName: translations[currentLanguage].phoneno,
        minWidth: 150,
        flex: 1,
      },
      {
        field: "whatsapp_number",
        headerName: "WhatsApp Number",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "manufacturer_name",
        headerName: "Manufacture Name",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "new_modal",
        headerName: "Model Name",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "new_tractor_price",
        headerName: "New Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.new_tractor_price || 0)}`,
      },
      {
        field: "old_details",
        headerName: "Old Tractors",
        headerAlign: "left",
        align: "left",
        minWidth: 250,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.old_details || ""),
      },
      {
        field: "old_tractor_price",
        headerName: "Old Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.old_tractor_price || 0)}`,
      },
      {
        field: "delivery_date",
        headerName: translations[currentLanguage].expdelivery,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.delivery_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "primary_source",
        headerName: "Primary Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.primary_source || ""),
      },
      {
        field: "enquiry_source",
        headerName: "Enquiry Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.enquiry_source || ""),
      },
      {
        field: "enquiry_date",
        headerName: "Enquiry date",
        headerAlign: "left",
        align: "left",
        minWidth: 130,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.enquiry_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "created_by",
        headerName: "Created By",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.created_by || ""),
      },
      {
        field: "payment_mode",
        headerName: "Payment Method",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.payment_mode || ""),
      },
      {
        field: "payment_details",
        headerName: "Payment Details",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.payment_details || ""),
      },

      {
        field: "last_discussion",
        headerName: "Last Discussion",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.last_discussion || ""),
      },
      {
        field: "last_followup_date",
        headerName: "Last Followup Date",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.last_followup_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "last_followed_person",
        headerName: "Last Followup Person",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.last_followed_person || ""),
      },
      {
        field: "menu",
        headerName: (
          <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
        ),
        className: "bg-dark",
        sortable: false,
        filterable: false,
        headerAlign: "right",
        align: "right",
        disableColumnMenu: true,
        width: 180,
        // flex: 1,
        position: "sticky",
        renderCell: (params) => (
          <div className="d-flex justify-content-center dotHoverempicon">
            <FontAwesomeIcon icon={faEllipsisV} />
            <div className="expandDiv expandDivenq">
              <Tooltip title="Edit">
                <button
                  onClick={() => {
                    editEnquiryCell(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Delete">
                <button
                  onClick={() => {
                    deleteActionCall(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-trash3"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Move to Stage">
                <div
                  className="position-relative"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <button
                    className="myActionBtn m-1"
                    onClick={() => handleStageClick(params.row)}
                  >
                    <LabelImportantIcon />
                  </button>
                </div>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ],
    WARM: [
      { field: "indexID", headerName: "ID", width: 90 },
      {
        field: "first_name",
        headerAlign: "left",
        align: "left",
        headerName: translations[currentLanguage].firstname,
        minWidth: 310,
        flex: 1,
        renderCell: (params) => {
          const fistName = params.row.first_name || " ";
          return (
            <div
              style={{
                textDecoration: "underline",
                color: "#000102",
                cursor: "pointer",
              }}
              onClick={() => {
                editEnquiryCell(params.row);
              }}
            >
              {toTitleCase(fistName)}
            </div>
          );
        },
      },
      {
        field: "sales_person_name",
        headerName: translations[currentLanguage].salesp,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
      },

      {
        field: "stage_name",
        headerName: "Stage Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "next_followup_date",
        headerName: "Next Followup Date",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.next_followup_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "village_name",
        headerName: translations[currentLanguage].village,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "taluka_name",
        headerName: translations[currentLanguage].taluka,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
      },
      {
        field: "district_name",
        headerName: translations[currentLanguage].district,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "phone_number",
        headerName: translations[currentLanguage].phoneno,
        minWidth: 150,
        flex: 1,
      },
      {
        field: "whatsapp_number",
        headerName: "WhatsApp Number",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "manufacturer_name",
        headerName: "Manufacture Name",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "new_modal",
        headerName: "Model Name",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "new_tractor_price",
        headerName: "New Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.new_tractor_price || 0)}`,
      },
      {
        field: "old_details",
        headerName: "Old Tractors",
        headerAlign: "left",
        align: "left",
        minWidth: 250,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.old_details || ""),
      },
      {
        field: "old_tractor_price",
        headerName: "Old Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.old_tractor_price || 0)}`,
      },
      {
        field: "delivery_date",
        headerName: translations[currentLanguage].expdelivery,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.delivery_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "primary_source",
        headerName: "Primary Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.primary_source || ""),
      },
      {
        field: "enquiry_source",
        headerName: "Enquiry Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.enquiry_source || ""),
      },
      {
        field: "enquiry_date",
        headerName: "Enquiry date",
        headerAlign: "left",
        align: "left",
        minWidth: 130,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.enquiry_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "created_by",
        headerName: "Created By",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.created_by || ""),
      },
      {
        field: "payment_mode",
        headerName: "Payment Method",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.payment_mode || ""),
      },
      {
        field: "payment_details",
        headerName: "Payment Details",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.payment_details || ""),
      },

      {
        field: "last_discussion",
        headerName: "Last Discussion",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.last_discussion || ""),
      },
      {
        field: "last_followup_date",
        headerName: "Last Followup Date",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.last_followup_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "last_followed_person",
        headerName: "Last Followup Person",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.last_followed_person || ""),
      },
      {
        field: "menu",
        headerName: (
          <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
        ),
        className: "bg-dark",
        sortable: false,
        filterable: false,
        headerAlign: "right",
        align: "right",
        disableColumnMenu: true,
        width: 180,
        // flex: 1,
        position: "sticky",
        renderCell: (params) => (
          <div className="d-flex justify-content-center dotHoverempicon">
            <FontAwesomeIcon icon={faEllipsisV} />
            <div className="expandDiv expandDivenq">
              <Tooltip title="Edit">
                <button
                  onClick={() => {
                    editEnquiryCell(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Delete">
                <button
                  onClick={() => {
                    deleteActionCall(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-trash3"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Move to Stage">
                <div
                  className="position-relative"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <button
                    className="myActionBtn m-1"
                    onClick={() => handleStageClick(params.row)}
                  >
                    <LabelImportantIcon />
                  </button>
                </div>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ],
    OLD: [
      { field: "indexID", headerName: "ID", width: 90 },
      {
        field: "first_name",
        headerAlign: "left",
        align: "left",
        headerName: translations[currentLanguage].firstname,
        minWidth: 310,
        flex: 1,
        renderCell: (params) => {
          const fistName = params.row.first_name || " ";
          return (
            <div
              style={{
                textDecoration: "underline",
                color: "#000102",
                cursor: "pointer",
              }}
              onClick={() => {
                editEnquiryCell(params.row);
              }}
            >
              {toTitleCase(fistName)}
            </div>
          );
        },
      },
      {
        field: "sales_person",
        headerName: translations[currentLanguage].salesp,
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.sales_person || ""),
      },
      {
        field: "stage_name",
        headerName: "Stage Name",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.stage_name || ""),
      },
      {
        field: "village",
        headerName: translations[currentLanguage].village,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.village || ""),
      },
      {
        field: "taluka",
        headerName: translations[currentLanguage].taluka,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 120,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.taluka || ""),
      },
      {
        field: "district",
        headerName: translations[currentLanguage].district,
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.district || ""),
      },
      {
        field: "phone_number",
        headerName: translations[currentLanguage].phoneno,
        minWidth: 120,
        flex: 1,
      },
      {
        field: "whatsapp_number",
        headerName: "WhatsApp Number",
        minWidth: 150,
        flex: 1,
      },

      {
        field: "manufacturer_name",
        headerName: "Manufacture Name",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.manufacturer_name || ""),
      },
      {
        field: "new_modal",
        headerName: "Model Name",
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          const product =
            params.row.new_modal === "null" ? "  " : params.row.new_modal;
          return <div>{toTitleCase(product)}</div>;
        },
      },
      {
        field: "new_tractor_price",
        headerName: "New Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.new_tractor_price || 0)}`,
      },
      {
        field: "old_details",
        headerName: "Old Tractors",
        headerAlign: "left",
        align: "left",
        minWidth: 250,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.old_details || ""),
      },
      {
        field: "old_tractor_price",
        headerName: "Old Tractor Price",
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) =>
          `${new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
          }).format(params.row.old_tractor_price || 0)}`,
      },
      {
        field: "delivery_date",
        headerName: translations[currentLanguage].expdelivery,
        headerAlign: "left",
        align: "left",
        minWidth: 150,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.delivery_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      // {
      //   field: "category_name",
      //   headerName: translations[currentLanguage].category,
      //   minWidth: 200,
      //   headerAlign: "left",
      //   align: "left",
      //   flex: 1,
      //   renderCell: (params) => {
      //     const category = params.row.enquiry_category_id || "";
      //     const rowId = params.row.id;
      //     return (
      //       <div className="">
      //         {showSelectionBox[rowId] ? (
      //           <select
      //             onChange={(e) => onChangeEnquiryCategory(e, params.row.id)}
      //             // className={statusDropDown}
      //             className={`custom-select ${statusDropDown}`}
      //             name="category_name"
      //             value={params.row.category_name}
      //           >
      //             <option value="">{params.row.category_name}</option>
      //             {newAddCategory.listTaskCategory?.length > 0 &&
      //               newAddCategory.listTaskCategory.map((i) => (
      //                 <option key={i.id} value={i.id} className="">
      //                   {i.category_name}
      //                 </option>
      //               ))}
      //           </select>
      //         ) : (
      //           <p
      //             className="clickable-text rounded-pill px-4"
      //             onClick={() => handleTaskStatus(rowId)}
      //           >
      //             {params.row.category_name}
      //           </p>
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        field: "enquiry_date",
        headerName: translations[currentLanguage].enqdate,
        headerAlign: "left",
        align: "left",
        minWidth: 130,
        flex: 1,
        valueGetter: (params) => {
          const date = params.row.enquiry_date;
          // Check if the date exists and is a valid date
          if (date && moment(date, moment.ISO_8601, true).isValid()) {
            return moment(date).format("DD/MM/YYYY");
          } else {
            // Handle cases where the date is invalid or missing
            return null;
          }
        },
      },
      {
        field: "primary_source",
        headerName: "Primary Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.primary_source || ""),
      },
      {
        field: "enquiry_source",
        headerName: "Enquiry Source",
        headerAlign: "left",
        align: "left",
        type: "text",
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.enquiry_source || ""),
      },
      {
        field: "created_by",
        headerName: "Created By",
        headerAlign: "left",
        align: "left",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => toTitleCase(params.row.created_by || ""),
      },
      {
        field: "menu",
        headerName: (
          <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
        ),
        className: "bg-dark",
        sortable: false,
        filterable: false,
        headerAlign: "right",
        align: "right",
        disableColumnMenu: true,
        width: 180,
        // flex: 1,
        position: "sticky",
        renderCell: (params) => (
          <div className="d-flex justify-content-center dotHoverempicon">
            <FontAwesomeIcon icon={faEllipsisV} />
            <div className="expandDiv expandDivenq">
              <Tooltip title="Work Assign">
                <button
                  className="myActionBtn m-1"
                  onClick={() => {
                    handleworkAssign(params.row, true);
                  }}
                >
                  <PersonIcon />
                </button>
              </Tooltip>
              <Tooltip title="Edit">
                <button
                  onClick={() => {
                    editEnquiryCell(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Delete">
                <button
                  onClick={() => {
                    deleteActionCall(params.row);
                  }}
                  className="myActionBtn m-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-trash3"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                  </svg>
                </button>
              </Tooltip>
              <Tooltip title="Move to Stage">
                <div
                  className="position-relative"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <button
                    className="myActionBtn m-1"
                    onClick={() => handleStageClick(params.row)}
                  >
                    <LabelImportantIcon />
                  </button>
                </div>
              </Tooltip>
            </div>
          </div>
        ),
      },
    ],
  });

  // Map of hardcoded header labels to translation keys/values
  const headerMap = {
    "Stage Name": t.stagename || "Stage Name",
    "WhatsApp Number": t.whatsappnumber || "WhatsApp Number",
    "Manufacture Name": t.manufacturename || "Manufacture Name",
    "Model Name": t.modelname || "Model Name",
    "New Tractor Price": t.newtractorprice || "New Tractor Price",
    "Old Tractors": t.oldtractors || "Old Tractors",
    "Old Tractor Price": t.oldtractorprice || "Old Tractor Price",
    "Primary Source": t.primarysource || "Primary Source",
    "Enquiry Source": t.enquirysource || "Enquiry Source",
    "Created By": t.createdby || "Created By",
    "Next Followup Date": t.nextfollowupdate || "Next Followup Date",
    "Enquiry Date": t.enqdate || "Enquiry Date",
    "Payment Method": t.paymentMethod || "Payment Method",
    "Payment Details": t.paymentDetails || "Payment Details",
    "Last Discussion": t.lastDiscussion || "Last Discussion",
    "Last Followup Date": t.lastFollowupDate || "Last Followup Date",
    "Last Followup Person": t.lastFollowupPerson || "Last Followup Person",
    ID: t.id || "ID",
  };

  const localizeColumns = (cols) => {
    if (!Array.isArray(cols)) return cols;
    return cols.map((col) => {
      if (typeof col.headerName === "string") {
        return { ...col, headerName: headerMap[col.headerName] || col.headerName };
      }
      return col;
    });
  };

  const handleMouseOver = () => {
    setIsHovered(true);
  };
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleStartDateChange = (date) => {
    setStartDate(date);
  };
  const handleMouseOut = () => {
    setIsHovered(false);
  };
  const [selectAll, setSelectAll] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [taskCategory, setEnquiryCategory] = useState(null);
  const [newEnquiryData, setNewEnquiryData] = useState({
    dsp: "",
  });
  const [statusVisible, setStatusVisible] = useState("none");
  const [showSelectionBox, setShowSelectionBox] = useState({});
  const [selectedPerson, setSelectedPerson] = useState([]);
  const navigate = useNavigate();
  const currentBranch = localStorage.getItem("currentDealerId");
  console.log(currentBranch, "currentBranch*******");
  const [newAddCategory, setNewAddCategory] = useState({
    listTaskCategory: [],
  });
  const [newEnquiryCategory, setNewEnquiryCategory] = useState({
    category: "",
  });
  const pageSizeKey = `rowsPerPage_${window.location.pathname}`;
  const [pageSize, setPageSize] = useState(() => {
    const saved = sessionStorage.getItem(pageSizeKey);
    return saved ? parseInt(saved, 10) : 50;
  }); // State to keep track of page size

  const stages = [
    // { label: "Hot", type: "HOT", color: "#FF6B6B" },
    // { label: "Cold", type: "COLD", color: "#4A90E2" },
    // { label: "Warm", type: "WARM", color: "#FFD93D" },
    { label: "Delivered", type: "DELIVERY", color: "#6BCB77", value: 2 },
    { label: "Invalid", type: "INVALID", color: "#9E9E9E", value: 2 },
    { label: "Lost", type: "LOST", color: "#F56C6C", value: 2 },
  ];

  // Function to handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    try { sessionStorage.setItem(pageSizeKey, String(newPageSize)); } catch (e) { }
  };
  async function getlisttaskCategory() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-enquiry-categories`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response) {
        setNewAddCategory((newAddCategory) => ({
          ...newAddCategory,
          ["listTaskCategory"]: response.data.result,
        }));
      }
    });
  }
  useEffect(() => {
    getlisttaskCategory();
  }, []);
  function updateEnquiryCategory(id, newCategory) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/update-enquiry-category/${id}/${newCategory}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    Axios.get(url, config)
      .then((response) => {
        if (response.data) {
          if (response.data.result === "success") {
            getEnquiriesFromDb();
            setStatusDropDown("status-dropdown");
            dispatch(setShowMessage("Category Updated"));
          }
        }
      })
      .catch((error) => {
        console.error("Error while updating task status:", error);
      });
  }
  async function updateEnquiryCategories(formData) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/update-enquiry-categories`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.post(url, formData, config).then((response) => {
      if (response.data) {
        if (response.data && response.data.isSuccess) {
          console.log(response.data.result, "result**********");
          getEnquiriesFromDb();
          setNewEnquiryCategory(response.data.result);
        }
      }
    });
  }
  const onChangeEnquiryCategory = (e, id) => {
    console.log(e, id, "jdbsdjsjdjsjdddddddddddddddddddddddddddddd");
    const newCategory = e.target.value;
    updateEnquiryCategory(id, newCategory);

    // Toggle the visibility of the selection box for the corresponding row
    setShowSelectionBox((prevState) => ({
      ...prevState,
      [id]: false,
    }));

    const updatedRowData = rowData.map((row) => {
      if (row.id === id) {
        return {
          ...row,
          category: newCategory,
        };
      }
      return row;
    });

    setRowData(updatedRowData);
  };
  function onChangeXLSXFile(e) {
    const file = e.target.files[0];
    if (file) {
      console.log(file, "selected xlsx file");
      setCsvFile(file);
      // Automatically trigger upload when a file is selected
      handleXlSXUpload(file);
    } else {
      setCsvFile("No file selected");
    }
  }

  const handleXlSXUpload = async (fileOverride) => {
    const fileToUpload = fileOverride || csvFile;
    if (!fileToUpload) {
      console.log("No XLSX file selected for upload");
      return;
    }
    console.log(fileToUpload, "csdielf");
    // Send the currently selected enquiry category so the server
    // can interpret the Excel rows in the context of that category.
    const url = `${process.env.REACT_APP_NODE_URL}/api/upload-xls?categoryId=${Category}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    const formData = new FormData();
    formData.append("enquiryxlxs", fileToUpload);
    try {
      const response = await Axios.post(url, formData, config);
      if (response.data && response.data.message === "Xlxs Success") {
        console.log(response.data, "CVEROTE");
        dispatch(setShowMessage("Data Successfully Inserted"));
        getEnquiriesFromDb();
      } else if (response.data && response.data.error === "Xlxs Failed") {
        dispatch(setShowMessage("Failed"));
      }
    } catch (error) {
      // Handle any errors here
      console.error("Error uploading CSV:", error);
    }
  };

  const downloadFile = async () => {
    try {
      // Pass currently selected enquiry category so that
      // the server can generate a sample specific to that category
      // (e.g. ITL Customer vs other categories with different fields).
      const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/download-file?categoryId=${Category}`;
      console.log(url, "urlurlurlurlurlurlurl");

      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error.message);
    }
  };

  // const handleCSVUpload = async () => {
  //   console.log(csvFile, "csdielf");
  //   const url = `${process.env.REACT_APP_NODE_URL}/api/upload-csv`;
  //   const config = {
  //     headers: {
  //       token: localStorage.getItem("rbacToken"),
  //     },
  //   };
  //   const formData = new FormData();
  //   formData.append("enquiryCSV", csvFile);
  //   try {
  //     const response = await Axios.post(url, formData, config);
  //     if (response.data && response.data.message === "CSV success") {
  //       console.log(response.data.message, "CVEROTE");
  //       dispatch(setShowMessage("Data Successfully Inserted"));
  //       getEnquiriesFromDb();
  //     } else if (response.data && response.data.error === "CSV failed") {
  //       dispatch(setShowMessage("Failed"));
  //     }
  //   } catch (error) {
  //     // Handle any errors here
  //     console.error("Error uploading CSV:", error);
  //   }
  // };

  // const handleHeaderCheckboxClick = () => {
  //   console.log('Heeloos')
  //   setSelectAll(!selectAll);
  //   const updatedRowData = rowData.map((item) => {
  //     return item.id
  //   })
  //   console.log(updatedRowData, 'updatet')
  // };

  const handleHeaderCheckboxClick = () => {
    console.log("Hello");
    setSelectAll(!selectAll);
    const updatedRowData = rowData.map((item) => {
      return item.id;
    });
    console.log(updatedRowData, "updated");
    setSelectedItemIds(updatedRowData);
  };
  useEffect(() => {
    console.log(selectAll, "selecteAll");
  }, [selectAll]);

  const handleChildCheckboxClick = (itemId) => {
    console.log(itemId, "itemId");
    const updatedRowsData = rowData.map((row) => {
      if (row.id === itemId) {
        return {
          ...row,
          checkbox: !row.checkbox,
        };
      }
      return row;
    });
    setRowData(updatedRowsData);

    // Update selected items array
    const updatedSelectedItems = updatedRowsData
      .filter((row) => row.checkbox)
      .map((row) => row.id);
    console.log(updatedSelectedItems, "updatedSelectedItems");
    setSelectedItemIds(updatedSelectedItems);
    setSelectedEmployeeIDs(updatedSelectedItems);
  };
  function onChangeEnquiryCategoryAll(data, isChecked) {
    console.log("&&&&&&&&&&&&&&77 data", data);
    console.log("&&&&&&&&&&&&&&77 isChecked", isChecked);
    let ids = "";
    let selectedRowsData = [];
    if (isChecked) {
      ids = data.id;
      console.log(ids, "idssjjjjjjjjjjjjjjjj");
    } else {
      console.log("evdata**********", selectedItemData);
      ids = selectedItemData.map((item) => item.id);
      console.log(ids, "idss");
    }
    try {
      setCustomerId(ids);
      setSelectedCategory(selectedItemData.category_name);
      const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-multiple-enquiriesbyEnquiryId/${ids}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = Axios.get(url, config);
      console.log(response.data, "data!!!!!!!!!!!");
      getlisttaskCategory();
      setShowComponentc(true);

      if (response.data && response.data.isSuccess) {
        const resultData = response.data.result;
        console.log("Result Data:", resultData);
        resultData.forEach((enquiry) => {
          console.log("Enquiry ID:", enquiry.enquiry_category_id);
          setSelectedPerson(enquiry);
        });
      } else {
        console.log(
          "No data received from the server or the request was not successful."
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  }
  function handleworkAssign(data, isChecked) {
    let ids = "";
    let selectedRowsData = [];
    if (isChecked) {
      ids = data.id;
      console.log(ids, "idsssdssdsds");
    } else {
      ids = selectedItemData.map((item) => item.id);
      console.log("evdata**********", selectedRowsData);
      console.log(ids, "idss");
    }
    try {
      setCustomerId(ids);
      setSelectedUser(selectedRowsData.sales_person);
      const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-multiple-enquiriesbyId/${ids}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };

      const response = Axios.get(url, config);
      console.log(response.data, "data!!!!!!!!!!!");
      getDspList(currentBranch);
      setShowComponent(true);

      if (response.data && response.data.isSuccess) {
        const resultData = response.data.result;
        console.log("Result Data:", resultData);
        resultData.forEach((enquiry) => {
          console.log("Enquiry ID:", enquiry.salesperson_id);

          setSelectedPerson(enquiry);
        });
      } else {
        console.log(
          "No data received from the server or the request was not successful."
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  }

  const handleNewEnquiry = () => {
    console.log(`Add ${ev_stage}`);
    const formattedType = formatType(ev_stage);
    navigate(`/sale/enquiries/${formattedType}/add`, {
      state: { ev_stage: { type: ev_stage, value: 2 } },
    });
  };

  const editEnquiryCell = (editEnquiryData) => {
    console.log(editEnquiryData, `Edit ${ev_stage}`);
    const formattedType = formatType(ev_stage);
    navigate(`/sale/enquiries/${formattedType}/edit`, {
      state: {
        ev_stage: { type: ev_stage, value: 2 },
        editData: editEnquiryData,
      },
    });
  };

  async function editsalesperson(formData) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/edit-salesperson-enquiry-data`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.post(url, formData, config).then((response) => {
      if (response.data) {
        if (response.data && response.data.isSuccess) {
          console.log(response.data.result, "result**********");
          setNewEnquiryData(response.data.result);
          getEnquiriesFromDb();
        }
      }
    });
  }
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const hideModal = () => {
    setShowComponent(false);
  };

  const hideModalc = () => {
    setShowComponentc(false);
  };

  const handleStageClick = (row) => {
    setModalData({
      show: true,
      rowData: row,
    });
  };

  const formatType = (type) =>
    type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

  const handleStageMove = async (stage, rowData) => {
    try {
      console.log(stage, rowData, "----->");
      const updatedRowData = {
        ...rowData,
        enquiry_created_date: rowData.date,
      };
      delete updatedRowData.date;
      const formattedType = formatType(stage.type);
      navigate(`/sale/data/${formattedType}/edit`, {
        state: { ev_stage: stage, editData: updatedRowData },
      });
    } catch (error) {
      console.log(error);
    }
  };

  async function getDspList(currentBranch) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-dsp/${currentBranch}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          console.log("response.data", response.data);
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listDsp"]: response.data.result,
          }));
        }
      }
    });
  }

  const handleFilterSelect = (option) => {
    console.log("Selected option:", option.id);
    setFilterEntity(option.id);
  };

  const getAllDates = (dates) => {
    // console.log(dates, "dates in getAll dates function$$$$$$$$$$$$$$$$$")
    const [startDate, endDate] = dates.map((date) => new Date(date));
    const dateArr = [];
    const formatDate = (date) => {
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    let currentDate = new Date(startDate);
    if (endDate === undefined) {
      dateArr.push(formatDate(currentDate));
      return dateArr;
    } else {
      while (currentDate <= endDate) {
        dateArr.push(formatDate(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return dateArr;
    }
  };

  const getEnquiriesByDates = async (date, selectType, category) => {
    let dateArr = selectType === "Custom" ? getAllDates(date) : date;

    const data = {
      dateArr: dateArr.join(","),
      category: category,
      ev_stage: ev_stage,
      dateForm: selectType === "All" ? "all" : undefined,
    };

    if (ev_stage === "OLD") {
      data.category = 3;
      setCategory(3);
    }

    const url = `${process.env.REACT_APP_NODE_URL}/api/general/get-enquiries-by-dates`;
    const token = await localStorage.getItem("rbacToken");

    const config = {
      headers: {
        token: token || "",
      },
    };

    try {
      setLoading(true);
      const response = await axios.post(url, data, config);
      if (response.data.isSuccess) {
        const result = response.data.result;
        console.log("Response:", response.data);
        setExcelKey(ev_stage);
        if (result[ev_stage]) {
          setIsAvailable((pre) => ({
            ...pre,
            [ev_stage]: true,
          }));      
          setEnquiries(result[ev_stage]);
          const customFields = result[ev_stage].map((custom) => {
            try {
              return custom.custom_fields
                ? JSON.parse(custom.custom_fields)
                : {};
            } catch {
              return {};
            }
          });
          const dynamicColumns = generateDynamicColumns(result.columns);
          const extractedColumns = extractRenderCellKeys(
            dynamicColumns,
            customFields,
            ev_stage,
            result[ev_stage] || []
          );
          setExcelColumns(extractedColumns);
          const allColumns = [
            { field: "indexID", headerName: "ID", width: 90 }, // Common ID column
            ...extractedColumns, // Add dynamically generated columns after the common column
          ];

          // if (ev_stage === "NEW") {
          //   setColumns((prevCol) => ({
          //     ...prevCol,
          //     [ev_stage]: allColumns,
          //   }));
          // }
        }

        // if (response.data.result.NEW) {
        //   setEnquiries(response.data.result.NEW);
        //   setIsAvailable((pre) => ({
        //     ...pre,
        //     NEW: true,
        //   }));
        // } else if (response.data.result.HOT) {
        //   setEnquiries(response.data.result.HOT);
        //   setIsAvailable((pre) => ({
        //     ...pre,
        //     HOT: true,
        //   }));
        // } else if (response.data.result.COLD) {
        //   setEnquiries(response.data.result.COLD);
        //   setIsAvailable((pre) => ({
        //     ...pre,
        //     HOT: true,
        //   }));
        // } else if (response.data.result.WARM) {
        //   setEnquiries(response.data.result.WARM);
        //   setIsAvailable((pre) => ({
        //     ...pre,
        //     HOT: true,
        //   }));
        // } else {
        //   setEnquiries([]);
        // }
      } else {
        setEnquiries([]);
      }
    } catch (error) {
      console.error("Error fetching enquiries:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const generateColumns = (columnsData) => {
    const dynamicColumns = columnsData.map((field) => {
      const baseConfig = {
        field: field.column,
        headerName: field.name,
        minWidth: 200,
        flex: 1,
        headerAlign: "left",
        align: "left",
      };

      return {
        ...baseConfig,
      };
    });

    const menuColumn = {
      field: "menu",
      headerName: (
        <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
      ),
      className: "bg-dark",
      sortable: false,
      filterable: false,
      headerAlign: "right",
      align: "right",
      disableColumnMenu: true,
      width: 180,
      renderCell: (params) => (
        <div className="d-flex justify-content-center dotHoverempicon">
          <FontAwesomeIcon icon={faEllipsisV} />
          <div className="expandDiv expandDivenq">
            <Tooltip title="Edit">
              <button
                className="myActionBtn m-1"
                onClick={() => editEnquiryCell(params.row)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </button>
            </Tooltip>
            <Tooltip title="Delete">
              <button
                onClick={() => deleteActionCall(params.row)}
                className="myActionBtn m-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-trash3"
                  viewBox="0 0 16 16"
                >
                  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                </svg>
              </button>
            </Tooltip>
          </div>
        </div>
      ),
    };

    return [...dynamicColumns, menuColumn];
  };
  function extractRenderCellKeys(dynamicColumns, customFields, ev_stage, stageData = []) {
    const extractedColumns = [];

    // Exclude the last item using slice
    const filteredColumns = dynamicColumns.slice(0, -1);

    filteredColumns.forEach((column) => {
      if (typeof column.renderCell === "function") {
        // Extract parameter keys from the renderCell function by inspecting its logic
        const paramsString = column.renderCell.toString();

        // Extract key names dynamically from params.row using a regex pattern
        const matchKeys = [
          ...new Set(
            paramsString
              .match(/params\.row\.(\w+)/g)
              ?.map((key) => key.split(".")[2])
          ),
        ];

        if (matchKeys) {
          matchKeys.forEach((key) => {
            extractedColumns.push({
              name: column.headerName || column.field || key,
              column: key,
              isChecked: false,
            });
          });
        }
      }
    });

    const seenKeys = new Set();
    customFields.forEach((custom) => {
      if (Object.keys(custom).length > 0) {
        Object.keys(custom).forEach((key) => {
          if (!seenKeys.has(key)) {
            seenKeys.add(key);
            extractedColumns.push({
              name: key,
              column: key,
              isChecked: false,
            });
          }
        });
      }
    });

    // Additional Columns
    let additionalColumns = [
      { name: "Old Tractor", column: "old_details", isChecked: false },
      {
        name: "Follow Up Details",
        column: "followup_details",
        isChecked: false,
      },
      { name: "Category", column: "category_name", isChecked: false },
    ];

    if (ev_stage === "NEW") {
      let newColumns = [
        { name: "Sales Person", column: "sales_person", isChecked: false },
        { name: "Stage Name", column: "stage_name", isChecked: false },
        { name: "First Name", column: "first_name", isChecked: false },
        { name: "Village", column: "village", isChecked: false },
        { name: "Taluko", column: "taluka", isChecked: false },
        { name: "District", column: "district", isChecked: false },
        { name: "Phone Number", column: "phone_number", isChecked: false },
        {
          name: "Whatsapp Number",
          column: "whatsapp_number",
          isChecked: false,
        },
        { name: "Model Name", column: "new_modal", isChecked: false },
        {
          name: "New Tractor Price",
          column: "new_tractor_price",
          isChecked: false,
        },
        { name: "Old Tractor", column: "old_details", isChecked: false },
        {
          name: "Old Tractor Price",
          column: "old_tractor_price",
          isChecked: false,
        },
        {
          name: "Expected Delivery Date",
          column: "delivery_date",
          isChecked: false,
        },
        { name: "Primary Source", column: "primary_source", isChecked: false },
        { name: "Enquiry Source", column: "enquiry_source", isChecked: false },
        { name: "Enquiry Date", column: "enquiry_date", isChecked: false },
        { name: "Created By", column: "created_by", isChecked: false },
      ];
      return newColumns;
    }

    if (ev_stage === "OLD") {
      let newColumns = [
        { name: "Sales Person", column: "sales_person", isChecked: false },
        { name: "Stage Name", column: "stage_name", isChecked: false },
        { name: "First Name", column: "first_name", isChecked: false },
        { name: "Village", column: "village", isChecked: false },
        { name: "Taluko", column: "taluka", isChecked: false },
        { name: "District", column: "district", isChecked: false },
        { name: "Phone Number", column: "phone_number", isChecked: false },
        {
          name: "Whatsapp Number",
          column: "whatsapp_number",
          isChecked: false,
        },
        { name: "Model Name", column: "new_modal", isChecked: false },
        {
          name: "New Tractor Price",
          column: "new_tractor_price",
          isChecked: false,
        },
        { name: "Old Tractor", column: "old_details", isChecked: false },
        {
          name: "Old Tractor Price",
          column: "old_tractor_price",
          isChecked: false,
        },
        {
          name: "Expected Delivery Date",
          column: "delivery_date",
          isChecked: false,
        },
        { name: "Primary Source", column: "primary_source", isChecked: false },
        { name: "Enquiry Source", column: "enquiry_source", isChecked: false },
        { name: "Enquiry Date", column: "enquiry_date", isChecked: false },
        { name: "Created By", column: "created_by", isChecked: false },
      ];
      return newColumns;
    }

    let isType = ["HOT", "COLD", "WARM"];
    if (isType.includes(ev_stage)) {
      // Stage Columns
      let stageColumns = [
        { name: "Sales Person", column: "sales_person_name", isChecked: false },
        {
          name: "Next Followup Date",
          column: "next_followup_date",
          isChecked: false,
        },
        { name: "Stage Name", column: "stage_name", isChecked: false },
        { name: "First Name", column: "first_name", isChecked: false },
        { name: "Village", column: "village_name", isChecked: false },
        { name: "Taluko", column: "taluka_name", isChecked: false },
        { name: "District", column: "district_name", isChecked: false },
        { name: "Phone Number", column: "phone_number", isChecked: false },
        {
          name: "Whatsapp Number",
          column: "whatsapp_number",
          isChecked: false,
        },
        { name: "New Model", column: "new_modal", isChecked: false },
        {
          name: "New Tractor Price",
          column: "new_tractor_price",
          isChecked: false,
        },
        { name: "Old Tractor", column: "old_details", isChecked: false },
        {
          name: "Old Tractor Price",
          column: "old_tractor_price",
          isChecked: false,
        },
        {
          name: "Expected Delivery Date",
          column: "delivery_date",
          isChecked: false,
        },
        { name: "Primary Source", column: "primary_source", isChecked: false },
        { name: "Enquiry Source", column: "enquiry_source", isChecked: false },
        { name: "Enquiry Date", column: "enquiry_date", isChecked: false },
        { name: "Created By", column: "created_by", isChecked: false },

        { name: "Payment Methods", column: "payment_mode", isChecked: false },
        {
          name: "Payment Details",
          column: "payment_details",
          isChecked: false,
        },
        {
          name: "Last Followup Date",
          column: "last_followup_date",
          isChecked: false,
        },
        {
          name: "Last Followup Person",
          column: "last_followed_person",
          isChecked: false,
        },
        { name: "All Remarks", column: "all_remarks", isChecked: true },
      ];

      return stageColumns;
    }

    return [...extractedColumns, ...additionalColumns];
  }

  // Function to generate dynamic columns based on the data
  const generateDynamicColumns = (columnsData) => {
    const dynamicColumns = columnsData.map((field) => {
      const baseConfig = {
        field: field.name,
        headerName: field.label,
        // minWidth: 200,
        minWidth: field.name === "firstName" ? 310 : 150,
        flex: 1,
        headerAlign: "left",
        align: "left",
      };

      const renderCellMapping = {
        branchId: (params) => toTitleCase(params.row.branch_name || " "),
        firstName: (params) => (
          <div
            style={{
              textDecoration: "underline",
              color: "#000102",
              cursor: "pointer",
            }}
            onClick={() => editEnquiryCell(params.row)}
          >
            {toTitleCase(params.row.first_name || " ")}
          </div>
        ),
        lastName: (params) => toTitleCase(params.row.last_name || " "),
        email: (params) => params.row.email || " ",
        mobileNumber: (params) => params.row.phone_number || " ",
        whatsappNumber: (params) => params.row.whatsapp_number || " ",
        district: (params) => toTitleCase(params.row.district || " "),
        taluko: (params) => toTitleCase(params.row.taluka || " "),
        village: (params) => toTitleCase(params.row.village || " "),
        dsp: (params) => toTitleCase(params.row.sales_person || " "),
        category_name: (params) => toTitleCase(params.row.category_name || " "),
        manufature: (params) => toTitleCase(params.row.manufacturer_name || " "),
        modal: (params) => toTitleCase(params.row.product || " "),
        engineNumber: (params) => params.row.engine_no || " ",
        chassis_no: (params) => params.row.chassis_no || " ",
        newPrice: (params) => formatDisplayNumber(params.row.new_tractor_price) || " ",
        isOldOwned: (params) => params.row.isOldOwned || " ",
        oldmake: (params) => toTitleCase(params.row.oldmake || " "),
        oldmodel: (params) => toTitleCase(params.row.oldmodel || " "),
        oldyear: (params) => params.row.oldyear || " ",
        oldPrice: (params) => formatDisplayNumber(params.row.old_tractor_price) || " ",
        totalHours: (params) => params.row.total_hours || " ",
        tractorNo: (params) => params.row.tractor_no || " ",
        oldCondition: (params) => toTitleCase(params.row.old_condition || " "),
        paymentMethod: (params) => toTitleCase(params.row.payment_mode || " "),
        paymentDetail: (params) => toTitleCase(params.row.payment_details || " "),
        bank: (params) => toTitleCase(params.row.bankname || " "),
        remainingPrice: (params) => formatDisplayNumber(params.row.remaining_price) || " ",
        primarySource: (params) => toTitleCase(params.row.primary_source || " "),
        enquirySource: (params) => toTitleCase(params.row.enquiry_source || " "),
        enquiryDate: (params) =>
          moment(params.row.date).format("YYYY-MM-DD") || " ",
        deliveryDate: (params) =>
          moment(params.row.delivery_date).format("YYYY-MM-DD") || " ",
      };
      return {
        ...baseConfig,
        renderCell: renderCellMapping[field.name] || null,
      };
    });

    const menuColumn = {
      field: "menu",
      headerName: (
        <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
      ),
      className: "bg-dark",
      sortable: false,
      filterable: false,
      headerAlign: "right",
      align: "right",
      disableColumnMenu: true,
      width: 180,
      renderCell: (params) => (
        <div className="d-flex justify-content-center dotHoverempicon">
          <FontAwesomeIcon icon={faEllipsisV} />
          <div className="expandDiv expandDivenq">
            <Tooltip title="Work Assign">
              <button
                className="myActionBtn m-1"
                onClick={() => {
                  handleworkAssign(params.row, true);
                }}
              >
                <PersonIcon />
              </button>
            </Tooltip>
            <Tooltip title="Edit">
              <button
                className="myActionBtn m-1"
                onClick={() => editEnquiryCell(params.row)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </button>
            </Tooltip>
            <Tooltip title="Delete">
              <button
                onClick={() => deleteActionCall(params.row)}
                className="myActionBtn m-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-trash3"
                  viewBox="0 0 16 16"
                >
                  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                </svg>
              </button>
            </Tooltip>
            <Tooltip title="Move to Stage">
              <div
                className="position-relative"
                style={{ display: "flex", alignItems: "center" }}
              >
                <button
                  className="myActionBtn m-1"
                  onClick={() => handleStageClick(params.row)}
                >
                  <LabelImportantIcon />
                </button>
              </div>
            </Tooltip>
          </div>
        </div>
      ),
    };

    return [...dynamicColumns, menuColumn];
  };

  useEffect(() => {
    if (filterEntity) {
      console.log(filterEntity, "Categorironqueri");
      const getCategoryEnquiry = async () => {
        const url = `${process.env.REACT_APP_NODE_URL}/api/get-enquiries-by-category/${filterEntity}`;
        console.log("get enquries", url);
        const token = await localStorage.getItem("rbacToken");
        const config = {
          headers: {
            token: token ? token : "",
          },
        };
        // setLoading(true);
        console.log(config);
        await axios.get(url, config).then((response) => {
          if (response) {
            // console.log(response.data.result, 'enquirie catrogrit');
            setEnquiries(response.data.result);
          }
        });
        // setLoading(false);
        // dispatch(setEnquiryType('All'));
      };
      getCategoryEnquiry();
    }
  }, [filterEntity]);

  const deleteActionCall = (data) => {
    setType("enquiry_delete");
    setEnquiryId(data.id);
    setDeleteMessage(
      `Are You Sure You Want To Delete The Enquiry '${data.first_name} ${data.last_name}'?`
    );
    setDisplayConfirmationModal(true);
  };
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const submitDelete = async () => {
    if (!enquiryId) return;

    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/delete-enquiry/${enquiryId}`;
      const config = {
        headers: { token: localStorage.getItem("rbacToken") },
      };
      const response = await axios.delete(url, config);
      const { isSuccess } = response.data || {};

      if (isSuccess) {
        dispatch(setShowMessage("Enquiry deleted successfully"));
        await getEnquiriesByDates(selectedDates, selectedType, Category);
        setDisplayConfirmationModal(false);
      } else {
        dispatch(setShowMessage("Failed to delete"));
      }
    } catch (error) {
      console.error("Error deleting enquiry:", error);
      dispatch(setShowMessage("Something went wrong"));
    }
  };


  function handleSubmit() {
    console.log("form save");
    console.log("newEnquiryList", newEnquiryList);
    if (newEnquiryData.dsp) {
      console.log("newEnquiryData", newEnquiryData);
      const formData = {
        customerId: customerId,
        salesperson_id: newEnquiryData.dsp,
      };
      console.log(formData, "formdata******");
      editsalesperson(formData);
    }
    dispatch(setShowMessage("Area is assigned"));
    setShowComponent(false);
  }
  const handleTaskStatus = (rowId) => {
    console.log(rowId, "rowIdrowIdrowId");
    if (showSelectionBox[rowId]) {
      // Selection box is already visible, make it invisible
      setShowSelectionBox((prevState) => ({
        ...prevState,
        [rowId]: false,
      }));
    } else {
      // Selection box is not visible, make it visible
      setShowSelectionBox((prevState) => ({
        ...prevState,
        [rowId]: true,
      }));
    }
  };

  function handleSubmitCategory() {
    console.log("form save");
    console.log("newAddCategory", newAddCategory);
    if (newEnquiryCategory.category) {
      console.log("newEnquiryCategory", newEnquiryCategory);
      const formData = {
        customerId: customerId, // Assuming you have customerId defined somewhere
        newCategory: newEnquiryCategory.category,
      };
      console.log(formData, "jkkjkkkkkkkkkkkkkkk");
      updateEnquiryCategories(formData);
    }
    dispatch(setShowMessage("Category Updated"));
    setShowComponentc(false);
  }

  const handleSelectedRowsChange = (selectedRows) => {
    console.log("Selected Rows:", selectedRows);
    setSelectedItemData(selectedRows);
  };

  const selectedData = rowData.filter((row) =>
    selectedItemIds.includes(row.id)
  );

  const handleSendMessages = async () => {
    navigate("/sale/enquiries/sendmessages", {
      state: { selectedData: selectedItemData },
    });
  };

  useEffect(() => {
    if (selectedItemIds) {
      console.log(selectedItemIds, "selecteddtsdi");
    }
  }, [selectedItemIds]);

  const handleEnquiryColumnShowHideChange = (enquiry_newShowHideModel) => {
    setEnquiryColumnShowHideModel(enquiry_newShowHideModel);
    localStorage.setItem(
      "enquiry_columnShowHide",
      JSON.stringify(enquiry_newShowHideModel)
    );
  };

  useEffect(() => {
    const enquiry_savedShowHideModel = JSON.parse(
      localStorage.getItem("enquiry_columnShowHide")
    );
    if (enquiry_savedShowHideModel) {
      setEnquiryColumnShowHideModel(enquiry_savedShowHideModel);
    }
  }, []);

  // const handleSelectionModelChange = (newSelectionModel) => {
  //   setSelectionModel(newSelectionModel);
  //   localStorage.setItem('selectionModel', JSON.stringify(newSelectionModel));
  // };

  // useEffect(() => {
  //   const savedSelectionModel = JSON.parse(localStorage.getItem('selectionModel'));
  //   if (savedSelectionModel) {
  //     setSelectionModel(savedSelectionModel);
  //   }
  // }, []);

  const getEnquiriesFromDb = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-enquiries`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    try {
      const response = await Axios.get(url, config);

      if (response.data?.isSuccess) {
        setEnquiries(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching enquiries:", error);
      throw error; // Rethrow the error for handling in the calling code
    }
  };

  useEffect(() => {
    const rowsData = enquiries.map((item, index) => ({
      ...item,
      indexID: index + 1,
    }));
    setRowData(rowsData);
  }, [enquiries]);

  const changeHandler = (e) => {
    console.log(e, "e**********");
    const name = e.target.name;
    const value = e.target.value;
    console.log(
      "in changeHandlerNewEnquiry <<name>>:",
      name,
      ", <<value>>:",
      value
    );
    setNewEnquiryData((newEnquiryData) => ({
      ...newEnquiryData,
      [name]: value,
    }));
  };
  const changeHandlerCategory = (e) => {
    console.log(e, "e**********");
    const name = e.target.name;
    const value = e.target.value;
    setNewEnquiryCategory((newEnquiryCategory) => ({
      ...newEnquiryCategory,
      [name]: value,
    }));
  };

  const handleCategoryChange = async (category) => {
    console.log(category, "Category->>>>>");
    if (category !== "Not") {
      setCategory(category.value);
      await getEnquiriesByDates(selectedDates, selectedType, category.value);
    }
  };

  const handleApplyButton = async (dates, type, category) => {
    console.log(dates, type, category, Category, "----->");
    setSelectedType(type);
    setSelectedDates(dates);
    if (category) {
      await getEnquiriesByDates(dates, type, category);
    } else {
      await getEnquiriesByDates(dates, type, Category);
    }
  };

  const renderDataGridTable = (columnKey) => {
    if (isAvailable[columnKey]) {
      return (
        <DataGridTable
          data={rowData}
          columns={localizeColumns(columns[columnKey])}
          onCheckboxChange={handleSelectedRowsChange}
        />
      );
    }
    return null;
  };

  return (
    <>
      <div>
        <div className="myTbl">
          <div className="container-fluid p-0 m-0">
            <ToolPanel
              isFileUploadEnabled={true}
              isAction={true}
              handleApplyButton={handleApplyButton}
              handleCategoryChange={
                ev_stage === "OLD" ? undefined : handleCategoryChange
              }
              ExcelSetup={{
                selectedDates,
                selectedType,
                category: Category,
                excelKey: excelKey,
                excelColumns: excelColumns,
              }}
              onFileChange={onChangeXLSXFile}
              onUpload={handleXlSXUpload}
              onAdd={ev_stage === "NEW" ? handleNewEnquiry : undefined}
              onWorkAssign={handleworkAssign}
              onSwapCategory={onChangeEnquiryCategoryAll}
              onMessageSend={handleSendMessages}
              onGet={downloadFile}
              onBack={() => {
                navigate("/sale/enquiries");
              }}
            />
          </div>
          {loading && (
            <div
              className="container"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                marginTop: "150px",
              }}
            >
              <FadeLoader size={16} color="#808b96" />
              <span
                style={{
                  // marginTop: "10px",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "16px",
                  color: "#808b96",
                }}
              >
                Loading, please wait...
              </span>
            </div>
          )}
          {renderDataGridTable(ev_stage)}
        </div>
        <Modal show={showComponent} onHide={hideModal}>
          <Modal.Header closeButton>
            <h5 className="modal-title" id="TalukaModalLabel">
              Work Assign
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className="">
              <div className="row mt-5">
                <h5>Select Sales Person</h5>

                <select
                  onChange={changeHandler}
                  defaultValue={selecteduser}
                  name="dsp"
                  className="myInput inpClr "
                >
                  <option value="0" className="myLabel">
                    select Sales Person
                  </option>
                  {newEnquiryList.listDsp &&
                    newEnquiryList.listDsp.length > 0 &&
                    newEnquiryList.listDsp.map((person) => {
                      const fullName = `${person.first_name} ${person.last_name}`;
                      return (
                        <option
                          key={person.id}
                          value={person.id}
                          className="myLabel"
                        >
                          {fullName}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={hideModal}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showComponentc} onHide={hideModalc}>
          <Modal.Header closeButton>
            <h5 className="modal-title" id="TalukaModalLabel">
              Change Category
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className="">
              <div className="row mt-5">
                <h5>Select Category</h5>

                <select
                  onChange={changeHandlerCategory}
                  defaultValue={selectedCategory}
                  name="category"
                  className="myInput inpClr "
                >
                  <option value="0" className="myLabel">
                    select Category
                  </option>
                  {newAddCategory.listTaskCategory &&
                    newAddCategory.listTaskCategory.length > 0 &&
                    newAddCategory.listTaskCategory.map((i) => {
                      const taskcategory = `${i.category_name}`;
                      return (
                        <option key={i.id} value={i.id} className="myLabel">
                          {taskcategory}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={hideModal}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmitCategory}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <AlertDeleteModal
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={enquiryId}
        message={deleteMessage}
      />
      <MovetoStageMenu
        showModal={modalData.show}
        onClose={() => setModalData({ show: false, rowData: null })}
        stages={stages}
        modalData={modalData.rowData}
        handleStageMove={handleStageMove}
      />
    </>
  );
}
